module.exports = __webpack_public_path__ + "static/media/aadith.3660eec8.jpeg";